import Vue from 'vue'
import Router from 'vue-router'
import routerM from './routerM'
import routerPC from './routerPC'

Vue.use(Router)

const ISMOBILE = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  console.log(flag)
  return flag
}

// 创建路由实例
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  fallback: false,
  // 这里判断后选择使用移动端的路由还是pc端的路由
  routes: ISMOBILE() ? routerM : routerM
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js